module.exports = __webpack_public_path__ + "ca29c434cece2b88ca74ad12539d5c1b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-30.png
// module id = 2091
// module chunks = 0